/** Shopify CDN: Minification failed

Line 15:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 21:8 Transforming let to the configured target environment ("es5") is not supported yet
Line 85:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 88:64 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 97:4 Transforming let to the configured target environment ("es5") is not supported yet

**/
/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper('#productSwiper');

productImages.update();

// thumbnail click
document.querySelectorAll('.productThumbnail').forEach(function (element) {
	element.addEventListener('click', function () {
		// determine index
		let index = getElIndex(this);

		// change active slide
		productImages.slideTo(index);
	});
});

// thumbnail change
productImages.on('slideChange', function (swiper) {
	document.querySelector('.productThumbnail.active').classList.remove('active');
	document.querySelectorAll('.productThumbnail')[swiper.realIndex].classList.add('active');
});

/*****************
 * Product Reviews / FAQ
 * *************/

// document.querySelector('#productStars').addEventListener("click", function () {
//     window.scroll({
//         behavior: "smooth",
//         top: document.querySelector("#reviews").offsetTop
//     });
// });
// document.querySelector('[href="#reviews"]').addEventListener("click", function (e) {
//     e.preventDefault();
//     window.scroll({
//         behavior: "smooth",
//         top: document.querySelector("#reviews").offsetTop
//     });
// });

// document.querySelector('[href="#faq"]').addEventListener("click", function (e) {
//     e.preventDefault();
//     window.scroll({
//         behavior: "smooth",
//         top: document.querySelector(".faq").offsetTop
//     });
// });

/****************
 * Variant Switcher
 */

// only for main sex chocolate
document.querySelectorAll('.productVariant').forEach(function (element) {
	element.addEventListener('click', function () {
		document.querySelector('.productVariant.active').classList.remove('active');
		this.classList.add('active');
	});
});

// variant dropdown
if (document.querySelector('#productVariantDropdown')) {
	document.querySelector('#productVariantDropdown').addEventListener('change', function () {
		activeVariant = product.variants.filter((variant) => variant.id == this.value)[0];
	});
}
/**************
 Product ATC
 ***************/

// default quantity
let quantity = 1;

// atc event listener
document.querySelector('#productATC').addEventListener('click', async function () {
	// add loading animation
	// document.querySelector("#productATC").classList.add("loading");

	var productATC = document.querySelector('#productATC');

	var originalChildren = productATC.innerHTML;

	productATC.innerHTML = `
    <div class="loader small">
			<div class="loader loader-undefined loader-active">
					<div class="loader-inner ball-pulse">
						<div></div>
						<div></div>
						<div></div>
					</div>
			</div>
    </div>
	`;

	// check for override, only for main sex chocolate
	if (document.querySelector('.productVariant.active')) {
		quantity = parseInt(document.querySelector('.productVariant.active').getAttribute('quantity'));
	}

	let formData = {
		id: activeVariant.id,
		quantity: quantity,
	};

	// facebook pixel
	try {
		fbq('track', 'AddToCart', {
			content_name: product.title,
			content_ids: [`${product.id}`],
			content_type: 'product',
			value: activeVariant.price / 100,
			currency: 'USD',
		});
	} catch (e) { }

	await addProduct(formData);
	await openCart();

	// remove loading animation
	setTimeout(function () {
		// document.querySelector("#productATC").classList.remove("loading");
		productATC.innerHTML = originalChildren;
	}, 500);

	// push to klavviyo
	// _learnq.push([
	// 	'track',
	// 	'Added to Cart',
	// 	{
	// 		$value: activeVariant.price,
	// 		AddedItemProductName: product.title,
	// 		AddedItemProductID: product.id,
	// 		AddedItemSKU: activeVariant.sku,
	// 		AddedItemCategories: product.tags,
	// 		AddedItemImageURL: product.featured_image,
	// 		AddedItemURL: `https://tabschocolate.com/products/${product.handle}`,
	// 		AddedItemPrice: activeVariant.price,
	// 		AddedItemQuantity: 1,
	// 		ItemNames: cart.items.map(function (item) {
	// 			return item.product_title;
	// 		}),
	// 		CheckoutURL: null,
	// 		Items: cart.items.map(function (item) {
	// 			return {
	// 				ProductID: item.product_id,
	// 				SKU: item.sku,
	// 				ProductName: item.product_title,
	// 				Quantity: item.quantity,
	// 				ItemPrice: item.price / 100,
	// 				RowTotal: item.line_price / 100,
	// 				ProductURL: `https://tabschocolate.com/products/${product.handle}`,
	// 				ImageURL: item.image,
	// 				ProductCategories: item.product_tags,
	// 			};
	// 		}),
	// 	},
	// ]);
});

/**************
 Product Tabs
 ***************/

document.querySelectorAll('div.product-faq-mini__item').forEach(function (element) {
	element.addEventListener('click', function () {
		//is this current one open, if so close
		if (this.classList.contains('active')) {
			this.classList.remove('active');
		} else {
			//check if already open
			if (document.querySelector('.product-faq-mini__item.active')) {
				document.querySelector('.product-faq-mini__item.active').classList.remove('active');
			}
			this.classList.add('active');
		}
	});
});

/***********
 * STicky ATC
 */

// show/hide
window.addEventListener('scroll', function () {
	if (
		window.scrollY >
		document.querySelector('#productATC').offsetTop + document.querySelector('#productATC').offsetHeight
	) {
		document.querySelector('#stickyATC').classList.add('active');
		document.body.classList.add('stickyATC--visible');
	} else {
		document.querySelector('#stickyATC').classList.remove('active');
		document.body.classList.remove('stickyATC--visible');
	}
});

// click
document.querySelector('#stickyATC').addEventListener('click', function () {
	window.scroll({
		behavior: 'smooth',
		top: document.querySelector('#productTitle').offsetTop,
	});
});
